'use strict';

var Faq = {
  openItem: function () {
    var faqHash = window.location.hash;
    if (faqHash.length && /#faq-/.test(faqHash)) {
      var accordionId = faqHash.replace('#faq-', 'accordion-'),
        $accordion = document.getElementById(accordionId);

      if (document.body.contains($accordion)) {
        $accordion.checked = true;
      }
    }
  }
};

Faq.openItem();

module.exports = Faq;
